module.exports = __webpack_public_path__ + "img/music.e9e8400a.png";